/*
 * Copyright (c) 2022. Dave van Rijn Development
 */

import {URLS} from "./api";
import {FetchMethod, ResponseData, sendFetch} from '@dvrd/dvr-controls';

interface Callback {
    callback: (data: ResponseData, response: Response) => void;
}

interface WithData<T> {
    data: T
}

/*
 ================================================
 Contact
 ================================================
 */
export type SendContact = {
    name: string;
    email: string;
    message: string;
    phone_number: string | null;
    city: string;
    service_type: string;
}

export const sendContact = (params: WithData<SendContact> & Callback) => {
    sendFetch({
        url: URLS.POST.CONTACT,
        method: FetchMethod.POST,
        data: params.data,
        callback: params.callback,
    });
};